import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable()
export class SharedService {
  public message = new BehaviorSubject("");
  sharedMessage = this.message.asObservable();

  public exposer = new BehaviorSubject("");
  sharedExposer = this.exposer.asObservable();

  public betSlipData = new BehaviorSubject("");
  sharedbetSlipData = this.betSlipData.asObservable();

  public betSlipRes = new BehaviorSubject("");
  sharedbetSlipRes = this.betSlipRes.asObservable();

  public tabCasino = new BehaviorSubject("");
  sharedTabCasino = this.tabCasino.asObservable();

  public tabCasinoI = new BehaviorSubject("");
  sharedTabCasinoI = this.tabCasinoI.asObservable();

  public sideMenu = new BehaviorSubject("");
  sharedSideMenu = this.sideMenu.asObservable();

  public stake = new BehaviorSubject("");
  sharedStake = this.stake.asObservable();

  public loginModal = new BehaviorSubject("");
  sharedLoginModal = this.loginModal.asObservable();

  public loginStatic = new BehaviorSubject("");
  sharedLoginStatic = this.loginStatic.asObservable();

  public cpModal = new BehaviorSubject(""); //change-password
  sharedCpModal = this.cpModal.asObservable();

  public login = new BehaviorSubject("");
  sharedLogin = this.login.asObservable();

  public updateExpoPusher = new BehaviorSubject("");
  sharedupdateExpoPusher = this.updateExpoPusher.asObservable();

  public updateUserAccPusher = new BehaviorSubject("");
  sharedupdateUserAccPusher = this.updateUserAccPusher.asObservable();

  constructor() {}

  nextMessage(message: any) {
    this.message.next(message);
  }

  emitExposer(data: any) {
    this.exposer.next(data);
  }

  emitbetSlipData(data: any) {
    this.betSlipData.next(data);
  }

  emitbetSlipRes(data: any) {
    this.betSlipRes.next(data);
  }

  emitTabCasino(data: any) {
    this.tabCasino.next(data);
  }

  emitTabCasinoI(data: any) {
    this.tabCasinoI.next(data);
  }

  emitSideMenu(data: any) {
    this.sideMenu.next(data);
  }

  emitStake(data: any) {
    this.stake.next(data);
  }

  emitLoginModal(data: any) {
    this.loginModal.next(data);
  }
  
  emitLoginStatic(data: any) {
    this.loginStatic.next(data);
  }

  emitCpModal(data: any) {
    this.cpModal.next(data);
  }

  emitLoginData(data: any) {
    this.login.next(data);
  }

  emitUpdateExpoPusher(data: any) {
    this.updateExpoPusher.next(data);
  }

  emitUpdateUserAccPusher(data: any) {
    this.updateUserAccPusher.next(data);
  }
}
